import { render, staticRenderFns } from "./KeyboardShortcut.html?vue&type=template&id=a8e51a1e&scoped=true&"
import script from "./KeyboardShortcut.js?vue&type=script&lang=js&"
export * from "./KeyboardShortcut.js?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcut.scss?vue&type=style&index=0&id=a8e51a1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e51a1e",
  null
  
)

export default component.exports